import { Status } from "@/modules/simulator/store";
import { visualization as api } from "../../api";
import moment from "moment";

const initialState = {
  reservoirInfo: null,
  status: Status.none,
  log: "",
  results: null,
  startedAt: null,
  timeElapsed: 0,
  vtkFiles: []
};

const actions = {
  async initialize({ commit, getters, dispatch }) {
    const { data } = await api.getConfig(getters.source);
    commit("SET_RESERVOIR_INFO", data.reservoir_info);
    commit("SET_STATUS", {
      status: data.status,
      log: data.log,
      results: data.results,
      startedAt: data.started_at,
      timeElapsed: data.time_elapsed,
      vtkFiles: data.vtk_files
    });
    if (data.status === Status.running) {
      dispatch("checkStatus");
    }
  },
  startVisualizationGeneration({ commit, getters, dispatch }, { epoch }) {
    commit("SET_RESERVOIR_INFO", { epoch });
    commit("SET_STATUS", {
      status: Status.running,
      log: "",
      results: null,
      startedAt: null,
      timeElapsed: 0,
      vtkFiles: []
    });
    api.generate(getters.source, epoch).then(({ data }) => {
      commit("SET_STATUS", {
        status: data.status,
        log: data.log,
        results: data.results,
        startedAt: data.started_at,
        timeElapsed: data.time_elapsed,
        vtkFiles: data.vtk_files
      });
      if (data.status === Status.running) {
        dispatch("checkStatus");
      }
    });
  },
  async stopVisualizationGeneration({ getters }) {
    await api.stopGenerate(getters.source);
  },
  checkStatus({ commit, getters }, timeout = 5000) {
    let timer = null;

    async function check() {
      const { data } = await api.getStatus(getters.source);

      if (data.status === Status.running) {
        clearTimeout(timer);
        timer = setTimeout(check, timeout);
      } else {
        commit("SET_STATUS", {
          status: data.status,
          log: data.log,
          results: data.results,
          startedAt: data.started_at,
          timeElapsed: data.time_elapsed,
          vtkFiles: data.vtk_files
        });
      }
    }

    timer = setTimeout(check, timeout);
  }
};

const mutations = {
  SET_STATUS(state, config) {
    state.status = config.status;
    state.log = config.log;
    state.results = config.results;
    state.startedAt = config.startedAt;
    state.timeElapsed = config.timeElapsed;
    state.vtkFiles = config.vtkFiles;
  },
  SET_RESERVOIR_INFO(state, reservoirInfo) {
    state.reservoirInfo = reservoirInfo;
  }
};

const getters = {
  source(state, getters, { common }) {
    return common.source;
  },
  reservoirInfoEpoch(state) {
    if (state.reservoirInfo) {
      return moment(state.reservoirInfo.epoch).format("DD/MM/YYYY HH:mm");
    }
    return "";
  }
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
